import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconForkKnife: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconForkKnife"><Path d="M6 3V10H7V3H9V10H10V3H12V11.4142L10 12.9142V21H6V12.9142L4 11.4142V3H6Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M19.0034 3H20.0034V21H16.0034V16H12.95L13.0048 14.948C13.2205 10.8058 14.2601 7.88907 15.4322 5.97732C16.0164 5.02446 16.6385 4.31345 17.2153 3.82841C17.5029 3.5865 17.7913 3.39071 18.0699 3.25085C18.3305 3.11997 18.6575 3 19.0034 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconForkKnife;
